import { LoadingTimeoutNotice } from "@/components/LoadingTimeoutNotice";

/** lazy 頁面（管理中心、列印、司機、簽收）載入中的畫面 */
export default function PageFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas p-4 text-ink">
      <p>正在載入頁面...</p>
      <LoadingTimeoutNotice />
    </div>
  );
}
